import React, { useState, useEffect, useRef } from 'react';
import { FaChevronDown, FaSearch } from 'react-icons/fa';

const SearchableSelect = ({ options, value, onChange, placeholder = "Select...", disabled = false, renderOption }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const wrapperRef = useRef(null);

    // Ensure options is always an array
    const safeOptions = Array.isArray(options) ? options : [];

    const filteredOptions = searchTerm
        ? safeOptions.filter(option =>
            option.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : safeOptions;

    useEffect(() => {
        // Close dropdown when clicking outside
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    const handleSelect = (option) => {
        onChange(option.value);
        setIsOpen(false);
        setSearchTerm('');
    };

    const selectedOption = safeOptions.find(option => option.value === value);
    const displayValue = selectedOption ? selectedOption.label : placeholder;

    return (
        <div className="relative w-full" ref={wrapperRef}>
            <div
                className={`w-full bg-background border border-border/50 rounded-md p-2 flex justify-between items-center cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={() => !disabled && setIsOpen(!isOpen)}
            >
                <span className={`text-foreground ${!value ? 'text-muted-foreground' : ''}`}>
                    {displayValue}
                </span>
                <FaChevronDown className="text-muted-foreground text-sm" />
            </div>

            {isOpen && (
                <div className="absolute z-10 w-full mt-1 bg-card border border-border/50 rounded-md shadow-lg max-h-60 overflow-hidden flex flex-col">
                    <div className="p-2 border-b border-border/50 sticky top-0 bg-card">
                        <div className="flex items-center bg-background px-2 rounded-md border border-border/50">
                            <FaSearch className="text-muted-foreground mr-2" />
                            <input
                                type="text"
                                className="w-full bg-transparent py-1 text-foreground focus:outline-none placeholder-muted-foreground"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                autoFocus
                            />
                        </div>
                    </div>
                    <ul className="overflow-y-auto flex-1">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map(option => (
                                <li
                                    key={option.value}
                                    className={`px-4 py-2 hover:bg-primary/20 cursor-pointer text-white ${value === option.value ? 'bg-primary/10' : ''}`}
                                    onClick={() => handleSelect(option)}
                                >
                                    {renderOption ? renderOption(option) : option.label}
                                </li>
                            ))
                        ) : (
                            <li className="px-4 py-2 text-muted-foreground text-center">No results found</li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default SearchableSelect;
